import sanitize from 'sanitize-html';
import parseUrl from 'url-parse';

import { allowedSchemes } from '../../createSanitizationProfile/createSanitizationProfile';

/**
 * Transforms `a` (anchor) tag by checking validity of the `href` attribute, and
 * if valid perform additional mods required for external links.
 *
 * @param tagName The name of the tag.
 * @param attributes The tag attributes.
 */
export const transformTagA: sanitize.Transformer = (tagName, attributes) => {
  try {
    const source = attributes.href.startsWith('www')
      ? `https://${attributes.href}`
      : attributes.href;

    const { href, host, protocol } = parseUrl(source);

    const isAllowedScheme = allowedSchemes.some(
      (allowedScheme) => protocol.replace(/:$/, '') === allowedScheme,
    );

    // sanitize-html mutates the returned attribs in place, so this must stay
    // a fresh, unfrozen object — immer's autofreeze would freeze it and crash
    // the strict-mode ESM bundle sanitize-html runs as under Vite.
    const tag: sanitize.Tag = {
      tagName,
      attribs: {
        ...attributes,
        href,
        ...(!isAllowedScheme
          ? {
              'data-scheme-not-allowed': 'true',
            }
          : {}),
      },
    };

    if (host && host !== window.parent.location.host) {
      tag.attribs.target = '_blank';
      tag.attribs.rel = 'noopener noreferrer nofollow';
    }

    return tag;
  } catch {
    // Strip the tag entirely if href is invalid.
    return { tagName: '', attribs: {} };
  }
};
